import api from './api';

class ReportService {
  normalizeReport(response) {
    return response.data?.data || response.data;
  }

  async getFinancialReport(params = {}) {
    const response = await api.post('/reports/financial', params);
    return this.normalizeReport(response);
  }

  async getPortfolioReport(params = {}) {
    const response = await api.post('/reports/portfolio', params);
    return this.normalizeReport(response);
  }

  async getAgencyPerformance(params = {}) {
    const response = await api.post('/reports/agency-performance', params);
    return this.normalizeReport(response);
  }

  async getLoanProductReport(params = {}) {
    const response = await api.post('/reports/loan-products', params);
    return this.normalizeReport(response);
  }

  async getClientReport(params = {}) {
    const response = await api.post('/reports/clients', params);
    return this.normalizeReport(response);
  }

  async getDailyCollectionReport(date) {
    const response = await api.get('/reports/daily-collection', { params: { date } });
    return response.data;
  }

  async exportReport(type, format = 'pdf', params = {}) {
    const response = await api.get(`/reports/export/${type}`, {
      params: { format, ...params },
      responseType: 'blob'
    });
    return response.data;
  }
}

export default new ReportService();
